import {
  CLASS_OF_ACCESSORY_TYPE,
  CLASS_OF_FASHION_TYPE,
  CLASS_OF_SHOE_TYPE,
  fieldsForClass,
} from "../fashionAttributes";

export const FASHION_DEPARTMENTS = ["Жінкам", "Чоловікам", "Унісекс / Для всіх"];

const TYPE_OPTIONS_BY_DEPT = {
  Жінкам: [
    "Футболки",
    "Майки/Топи",
    "Блузки/Сорочки",
    "Кофти/Світшоти",
    "Штани/Джинси",
    "Плаття",
    "Спідниці",
    "Костюми",
    "Верхній одяг",
    "Спортивний одяг",
    "Домашній одяг/Піжами",
    "Спідня білизна",
    "Купальники",
    "Одяг для вагітних",
    "Взуття",
    "Шапки/Головні убори",
    "Сумки/Рюкзаки",
    "Аксесуари",
    "Інше",
  ],
  Чоловікам: [
    "Футболки",
    "Майки",
    "Сорочки",
    "Кофти/Світшоти",
    "Штани/Джинси",
    "Костюми",
    "Верхній одяг",
    "Спортивний одяг",
    "Домашній одяг/Піжами",
    "Спідня білизна",
    "Взуття",
    "Шапки/Головні убори",
    "Сумки/Рюкзаки",
    "Аксесуари",
    "Інше",
  ],
  "Унісекс / Для всіх": [
    "Футболки",
    "Кофти/Світшоти",
    "Штани/Джинси",
    "Верхній одяг",
    "Спортивний одяг",
    "Домашній одяг/Піжами",
    "Взуття",
    "Шапки/Головні убори",
    "Сумки/Рюкзаки",
    "Аксесуари",
    "Інше",
  ],
};

// §42 — every characteristic below comes from the ONE canonical attribute registry
// (../fashionAttributes.js): which facets a product has is decided by its product CLASS,
// the value lists are the registry's, and the stored values are the registry's labels.

// Own sub-type fields (the first thing asked after the type) — they also refine the class.
const SUBTYPE_FIELD = {
  "Верхній одяг": { name: "typeOuter", label: "Тип", type: "select", options: ["Куртка", "Пальто", "Пуховик", "Плащ", "Парка", "Жилет"] },
  "Спортивний одяг": { name: "sportType", label: "Призначення", type: "select", options: ["Біг", "Фітнес/Зал", "Трекінг", "Йога", "Тренувальний комплект", "Інше"] },
  Купальники: { name: "set", label: "Комплект", type: "select", options: ["Цільний", "Роздільний"] },
  "Одяг для вагітних": { name: "maternityType", label: "Категорія", type: "select", options: ["Сукні", "Джинси/Штани", "Футболки/Блузки", "Світшоти/Кофти", "Інше"] },
  Взуття: { name: "shoeType", label: "Тип", type: "select", options: ["Кросівки", "Черевики", "Туфлі", "Босоніжки/Сандалі", "Чоботи", "Домашнє взуття", "Інше"] },
  "Шапки/Головні убори": { name: "hatType", label: "Тип", type: "select", options: ["Шапка", "Кепка", "Капелюх", "Панамка", "Бафф", "Інше"] },
  "Сумки/Рюкзаки": { name: "bagType", label: "Тип", type: "select", options: ["Сумка", "Рюкзак", "Клатч", "Поясна сумка", "Портфель", "Інше"] },
  Аксесуари: { name: "accessoryType", label: "Тип аксесуара", type: "select", options: ["Окуляри", "Ремінь", "Рукавиці/Рукавички", "Шарф", "Краватка/Метелик", "Годинник", "Прикраси", "Інше"] },
};

export const fashionFields = (attrs) => {
  const a = attrs || {};
  const dept = a.department || "";
  const type = a.type || "";

  const departmentOnly = [
    {
      name: "department",
      label: "Відділ",
      type: "select",
      options: FASHION_DEPARTMENTS,
      required: true,
    },
  ];
  if (!dept) return departmentOnly;

  const typeOnly = [
    ...departmentOnly,
    {
      name: "type",
      label: "Тип",
      type: "select",
      options: TYPE_OPTIONS_BY_DEPT[dept] || [],
      required: true,
    },
  ];
  if (!type) return typeOnly;

  // the product class: decided by the type, refined by the shoe / accessory sub-type
  let cls = CLASS_OF_FASHION_TYPE[type] || "clothing";
  if (type === "Взуття" && a.shoeType) cls = CLASS_OF_SHOE_TYPE[a.shoeType] || cls;
  if (type === "Аксесуари" && a.accessoryType) cls = CLASS_OF_ACCESSORY_TYPE[a.accessoryType] || cls;

  // a dress is a women's garment; a men's shirt is a shirt
  return [...typeOnly, ...(SUBTYPE_FIELD[type] ? [SUBTYPE_FIELD[type]] : []), ...fieldsForClass(cls, a)];
};
